import cx from "classnames"
import React, { PureComponent } from "react"
import ProductCard from "./product-card"
import MobliePanel from "./mobile-panel"
import { ProductsMatrixDataType } from "../homepage.module"
import { getGlobalConfig } from "../../../lib/global-config"

const styles = require("./main.styl")

interface Props {
    list: ProductsMatrixDataType[]
}

interface State {
    currentIndex: number
    direction: "up" | "down"
}

export default class ProductMatrix extends PureComponent<Props, State> {
    constructor(prop) {
        super(prop)
        this.state = {
            currentIndex: 0,
            direction: "up"
        }
    }
    render() {
        return (
            <div className={ styles["product-matrix"] }>
                <div className="product-matrix-images">
                    {this.renderImages()}
                    {this.renderBackgrounds()}
                </div>
                <div className="product-matrix-list">
                    {this.renderProductCard()}
                </div>
                <div className="product-matrix-mobile">
                    {this.renderMobileList()}
                </div>
            </div>
        )
    }
    renderImages() {
        const { list } = this.props
        const { currentIndex } = this.state
        return list.map(({ title, fontImage, enFontImage }, index) => {
            const delta = (index - currentIndex) * 7
            const className = cx([
                "product-matrix-images-font",
                delta === 0 ? "image-active" : ""
            ])
            const transform = `translate(-50%, ${delta - 50}%) ${
                delta !== 0 ? "scale(.98)" : ""
            }`
            return (
                <img
                    key={ title }
                    className={ className }
                    src={
                        getGlobalConfig().lang === "en"
                            ? enFontImage
                            : fontImage
                    }
                    style={{ transform: transform }}
                />
            )
        })
    }
    renderBackgrounds() {
        const { list } = this.props
        const { currentIndex } = this.state
        return list.map(({ title, backgroundLinear }, index) => {
            const backgroundLinearStyle = {
                background: `linear-gradient(to bottom right, ${
                    backgroundLinear[0]
                }, ${backgroundLinear[1]})`
            }
            return (
                <div
                    className={ cx("product-matrix-images-back", {
                        active: index === currentIndex
                    }) }
                    style={ backgroundLinearStyle }
                    key={ title }
                />
            )
        })
    }
    renderProductCard() {
        const { list } = this.props
        const { currentIndex } = this.state
        return list.map((props, index) => (
            <ProductCard
                key={ `${props.title}.${index}` }
                { ...props }
                active={ currentIndex === index }
                onMouseEnter={ this.onCardOver(index) }
            />
        ))
    }
    renderMobileList() {
        const { list } = this.props
        return list.map((props, index) => (
            <MobliePanel key={ index } { ...props } />
        ))
    }
    onCardOver = index => () => {
        const { currentIndex } = this.state
        if (index === currentIndex) {
            return
        }
        this.setState({
            currentIndex: index,
            direction: index > currentIndex ? "up" : "down"
        })
    }
}
